module.exports = __webpack_public_path__ + "img/pic.bdf22279.png";